import { render, staticRenderFns } from "./registertwo.vue?vue&type=template&id=200cb12a&scoped=true&"
import script from "./registertwo.vue?vue&type=script&lang=js&"
export * from "./registertwo.vue?vue&type=script&lang=js&"
import style0 from "./registertwo.vue?vue&type=style&index=0&id=200cb12a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200cb12a",
  null
  
)

export default component.exports